import React from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Box, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { chartDataState } from '../recoil/atom';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);

const MandaySummary = ({ height, width, criteriaDate }) => {
  const [chartData, setChartData] = useRecoilState(chartDataState);
  
  const sum = _.sumBy(chartData.filter(v => v.monthweek === "W"), 'PV_MD');
  
  const criteriaDateFormat = `${dayjs(criteriaDate).format("YY년")} ${dayjs(criteriaDate).week()}주`;
  const planData = chartData.filter(v => v.monthweek === "W").findIndex(v => v.date === criteriaDateFormat);
  const plan = planData ? _.sumBy(chartData.filter(v => v.monthweek === "W").slice(0, planData), "PV_MD") : 0;


  
  const actual = _.sumBy(chartData.filter(v => v.monthweek === "W"), 'EV_MD'); 

  return (
    <Box display="flex" justifyContent="center" alignItems="center" padding="20px" height={height-45}>
      <Box display="flex" justifyContent="space-between" width="80%">
        <Box textAlign="center">
          <Typography variant="caption">전체 MD</Typography>
          <Typography variant="subtitle1" sx={{fontSize:18, fontWeight:600}}>
            {sum.toFixed(0).toLocaleString()}MD
          </Typography>
        </Box>
        <Box textAlign="center">
          <Typography variant="caption">계획 MD</Typography>
          <Typography variant="subtitle1" sx={{fontSize:18, fontWeight:600}}>
            {plan.toFixed(0).toLocaleString()}MD
          </Typography>
        </Box>
        <Box textAlign="center">
          <Typography variant="caption">실적 MD</Typography>
          <Typography variant="subtitle1" sx={{fontSize:18, fontWeight:600}}>
            {actual?.toFixed(0).toLocaleString()}MD
          </Typography>
        </Box>
      </Box>
    </Box>
  )
};

export default MandaySummary